export const styles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		paddingTop: 4,
		marginBottom: 1
	},
	button_group: {
		display: 'flex'
	},
	buttons: {
		marginRight: 1
	},
	title: {
		marginBottom: 2
	}
};
